module.exports = __webpack_public_path__ + "static/media/img-feature-slider-3.9a948627.png";